module.exports = __webpack_public_path__ + "4a362c895d2563c74bd75d255744ad7b.png";